import { createSlice } from '@reduxjs/toolkit';
import { ParticipantSearchState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { participantSearchThunk } from './thunks';

const initialState: ParticipantSearchState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

export const participantSearchSlice = createSlice({
  name: 'participantSearch',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(participantSearchThunk.pending, (state) => {
      state.status = StoreStatus.BUSY;
      state.errors = null;
    });

    builder.addCase(participantSearchThunk.fulfilled, (state, action) => {
      state.status = StoreStatus.IDLE;
      state.errors = null;

      const isLoadMore = Boolean(action.meta.arg.nextToken);

      if (isLoadMore && state.response) {
        state.response = {
          items: [...state.response.items, ...action.payload.items],
          nextToken: action.payload.nextToken,
        };
      } else {
        state.response = action.payload;
      }
    });

    builder.addCase(participantSearchThunk.rejected, (state, { payload }) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
    });
  },
});

export const { reset } = participantSearchSlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default participantSearchSlice.reducer;
